var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H19.75V24.375H1V0ZM25.3783 20.625H44.1283V45H25.3783V20.625ZM25.3783 0H44.1283V15H25.3783V0ZM1 30H19.75V45H1V30Z",
    fill: "#58585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlocks);
export default __webpack_public_path__ + "static/media/ic-blocks.f76341139858c7345fe04737f0979177.svg";
export { ForwardRef as ReactComponent };